import { t } from "@/i18n-js/instance";
import { Badge } from "./Badge";

interface BuildingBlocksProps {
  blocks: string[];
}

const baseKey =
  "authentication_app.new_onboarding_flow_april_2025.community_preview.building_blocks";

const DEFAULTS = ["community", "website_builder", "email_marketing"].map(key =>
  t(`${baseKey}.${key}`),
);

export const BuildingBlocks = ({ blocks }: BuildingBlocksProps) => (
  <div className="flex flex-wrap gap-2">
    {DEFAULTS.map(defaultBlock => (
      <Badge key={defaultBlock} label={defaultBlock} isDefault />
    ))}
    {blocks.map(block => (
      <Badge key={block} label={block} isDefault={false} />
    ))}
  </div>
);
